import usePostData from '../../../../../hooks/postHook';

export const useAddCharacteristic = instructionId => {
  const [{ data, body, isLoading, isError, error }, doAddCharacteristic] =
    usePostData(`office_knowledge_base/${instructionId}/characteristics`);

  //const { type } = req.body;
  return { data, body, isLoading, isError, error, doAddCharacteristic };
};
